import React from 'react';
import moment from 'moment';

export const FooterCopyright = () => {
    const year = moment().year();
    return (
        <span className="footer-copyright">&copy;{year} The KTX ATS Platform. All Rights Reserved</span>
    )
};
